<template>
  <div class="apply_collection">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_div_apply_collection">
          <div class="security_main_body_div_H1_apply_collection">社交媒体营销</div>
          <div class="security_main_body_div_text">
            利用数据驱动智能社媒营销策略，在社交媒体上抢占先机，让您的品牌在全球范围内获得更大曝光和成功
          </div>
          <div class="security_main_body_div_butts_apply_collection">
            <div
              class="security_main_body_div_butt div_buttA"
              @click="loginshow"
            >
              免费试用
            </div>
            <div class="security_main_body_div_butt div_buttB" @click="topay">
              产品价格
            </div>
          </div>
          <div class="apply_collection_dzsw_d4_collection">
            <div>
              <img src="http://apiupss.ppfly.top/images/banner_icon4.svg" alt="" />
              <div>无限并发请求</div>
            </div>
            <div>
              <img style="width: 60px" src="http://apiupss.ppfly.top/images/banner_icon10.png" alt="" />
              <div>小于1s响应时间</div>
            </div>
            <div>

              <img style="width: 60px" src="http://apiupss.ppfly.top/images/banner_icon6.png" alt="" />
              <div>HTTP(S)/Socks5协议</div>
            </div>
            <div>
              <img
                style="width: 60px"
                src="http://apiupss.ppfly.top/images/banner_icon11.svg"
                alt=""
              />
              <div>企业定制服务</div>
            </div>
          </div>
        </div>

        <div class="security_main_body_divB_coll">
          <div class="security_main_body_divB_div">
            <div class="security_main_body_divB_div_left">
              <div>
                <div class="security_main_body_divB_div_left_H1">
                  全球化精准营销
                </div>
                <div class="security_main_body_divB_div_left_text">
                  让您专注于社交媒体营销，实现更广泛的曝光和用户互动
                </div>
              </div>

                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>覆盖目标受众</div>
                    <div class="applyele_list_img_text">
                      对收集的帖子、点赞、评论、标签和视频等数据进行分析，洞悉市场动向和消费者喜好，掌握流行趋势
                    </div>
                  </div>
                </div>

                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>发现用户需求</div>
                    <div class="applyele_list_img_text">
                      监控消费者情绪和需求，通过挖掘消费者话题、行为和互动数据，帮助您抓住市场热点，预测下一个大热趋势
                    </div>
                  </div>
                </div>


                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>提升品牌影响力</div>
                    <div class="applyele_list_img_text">
                      深入了解品牌在各大平台的曝光和影响力，制定更具针对性的营销活动，提高品牌曝光度和覆盖率
                    </div>
                  </div>
                </div>



            </div>
            <div class="security_main_body_divB_div_reft">
              <img src="http://apiupss.ppfly.top/images/introduce_r_7.svg" alt="" />
            </div>
          </div>
        </div>

        <apply_electronic_media />
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>
<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
import apply_electronic_media from "@/components/apply_electronic_media/apply_electronic_media.vue";
export default {
  // apply-market
  name: "apply_media",
  components: {
    Head,
    Footer,
    Xuanfuret,
    apply_electronic_media,
  },
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    topay() {
      this.$router
        .push({
          path: "/pay",
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
      this.$router.go(0);
    },
    loginshow() {
      const token = this.$cookies.get("userdata");
      if (token == null) {
        this.$router
          .push({
            path: "/userlogin",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
      }
    },
  },

  created() {},
  mounted() {
    this.totop();
  },
};
</script>
<style lang="scss" scoped>
.security_main_body {
  background-color: #f5f2f23a;
}
.security_main_body_div_apply_collection {
  background: url(http://apiupss.ppfly.top/images/home_banner.76027eb.webp);
  background-color: #edf3fc;
  background-repeat: no-repeat;
  padding-bottom: 200px;
  text-align: left;
  padding-left: 300px;
  // https://oss.kookeey.com/keekooy-next-dist/public/_nuxt/proxy-network_bg.1d9685a0.png
}
.security_main_body_div_H1_apply_collection {
  padding-top: 80px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 54px;
  color: #1b2336;
  line-height: 76px;
}
.security_main_body_div_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  width: 600px;
  font-size: 22px;
  color: rgba(18, 17, 39, 0.72);
  line-height: 40px;
}
.apply_collection_dzsw_d4_collection {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: left;
}
.apply_collection_dzsw_d4_collection > div{
  margin-right: 110px;
}
.apply_collection_dzsw_d4_collection img {
  margin-bottom: 30px;
}
.security_main_body_div_butts_apply_collection {
  display: flex;
  justify-content: left;
  margin: 80px 0 80px 0;
}

.security_main_body_div_butt {
  width: 191px;
  height: 54px;
  border-radius: 45px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  cursor: pointer;
  box-sizing: border-box;
}
.div_buttA {
  background: #3580ff;
  color: #edf3fc;
}
.div_buttB {
  background: transparent;
  border: 1px solid #0e1d3c;
  color: #0e1d3c;
}
.security_main_body_divB_coll {
  margin-top: -100px;
}
.security_main_body_divB_div {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 60px;
  background-color: #edf3fc;
  border-radius: 10px;
}
.security_main_body_divB_div_left {
  width: 50%;
  padding-top: 75px;
}
.security_main_body_divB_div_reft {
  width: 50%;
  margin-top: 60px;
}
.security_main_body_divB_div_left_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 36px;
  color: #1b2336;
  line-height: 40px;
  text-align: left;
}
.security_main_body_divB_div_left_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #565656;
  line-height: 26px;
  margin-top: 34px;
  margin-bottom: 24px;
  text-align: left;
}
.applyele_list_img {
  display: flex;
  justify-content: left;
  margin: 10px 0 10px 0;
}
.applyele_list_img > div {
  text-align: left;
  margin-right: 20px;
}
.applyele_list_img > div:nth-child(1) {
  text-align: left;
  margin-top: 5px;
}
.applyele_list_img_text {
  font-weight: 400;
  font-size: 14px;
  color: #565656;
  margin-top: 5px;
}
</style>
